<div class="task-tracker-widget">
  <div class="chart-container">
    <div id="chartdiv" class="chart"></div>
  </div>
  <div class="today-tasks">
    <h2>{{ todayTasksCount }}</h2>
    <p>Tasks Completed Today</p>
  </div>
  <!-- Drag Handle -->
  <div class="drag-handle" cdkDragHandle>
    <span  class="material-icons">
      drag_indicator
  </span>
  </div>
</div>
